import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";

import Home from "../views/Home.vue";
import Cotizar from "../views/Cotizar.vue";
import Plan from "../views/Plan.vue";
import Contratar from "../views/Contratar.vue";
import Gracias from "../views/Gracias.vue";
import CuotasMinimos from "../views/CuotasMinimos.vue";

import CapitaMinima from "../views/cuotas/viewCapitaMinima.vue";
import Monotributo from "../views/cuotas/viewMonotributo.vue";
import Adherentes from "../views/cuotas/viewAdherentes.vue";

Vue.use(VueRouter);
Vue.use(VueMeta);

Vue.config.productionTip = true;

// const NotFound = { template: "<div> no encontrado </div>" };
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "current-menu-item",
  routes: [
    { path: "/", name: "Home", component: Home },
    { path: "/cotizar", name: "Cotizar", component: Cotizar },
    { path: "/plan", name: "Plan", component: Plan, props: true },
    { path: "/contratar", name: "Contratar", component: Contratar },
    { path: "/gracias", name: "Gracias", component: Gracias },
    { path: "/cuotas", name: "Cuotas y Minimos", component: CuotasMinimos },
    {
      path: '/',
      component: CuotasMinimos,
  
      children: [
        
        {
          path: '/cuotas-y-minimos',
          name: 'capita',
          component: CapitaMinima,
        },
        {
          path: '/monotributo',
          name: 'monotributo',
          component: Monotributo,
        },
       
        {
          path: '/adherentes',
          name: 'adherentes',
          component: Adherentes,
        },
      ]
    },
    // { path: "*", component: NotFound },
  ],
});

export default router;
